import React from 'react';
 
/**
 * Reusable form input component
 * @param {Object} props
 * @param {string} props.id - Input id
 * @param {string} props.name - Input name
 * @param {string} props.type - Input type (text, email, tel, etc.)
 * @param {string} props.label - Label text
 * @param {string} props.value - Input value
 * @param {Function} props.onChange - Change handler
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.error - Error message
 * @param {boolean} props.required - Whether field is required
 * @param {Object} props.otherProps - Other input props
 */
const FormInput = ({
  id,
  name,
  type = 'text',
  label,
  value,
  onChange,
  placeholder,
  error,
  maxLength,
  required = false,
  ...otherProps
}) => {
  return (
    <div className="form-row">
      {label && (
        <label className="label-one" htmlFor={id}>
          {label}
          {required && <span style={{ color: '#dc2626' }}> *</span>}
        </label>
          )}
      <input
        id={id}
        name={name}
        type={type}
        maxLength={maxLength}
        className={`form-input ${error ? 'has-error' : ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...otherProps}
      />
      {error && <div className="error-text">{error}</div>}
    </div>
  );
};
 
export default FormInput;
 